import React, { Component } from 'react';
import Parser from 'html-react-parser'
import { DocumentIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';

class Main extends Component {
  static defaultProps = {

  }

  state = {

  }

  constructor(props) {
    super(props);
    this.state = {
      showCallForm: false,
    };
  }

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {

    const data = this.props?.data || {}
    const promo = data?.promo_ng || {}
    const { showCallForm } = this.state

    return (
      <>
        <div className='mt-[80px] xl:mt-[100px] w-full max-w-full'>
          <div className='container'>
            <div
              className='w-[calc(100%+20px)] ml-[-10px] sm:ml-0 sm:w-full bg-[#141414F5] bg-center bg-cover py-[80px] xl:py-0 px-[10px] xl:px-0 xl:min-h-[386px] rounded-[20px] xl:rounded-[28px] flex flex-col xl:flex-row items-center justify-around gap-[20px] xl:gap-[50px]'
              style={{ backgroundImage: `url('${promo?.fon}')` }}
            >
              <div>
                <div className='text-white text-title leading-none uppercase'>
                  {Parser(promo?.title || '')}
                </div>
                <div className='text-base leading-none text-white mt-[12px] max-w-[430px]'>
                  {Parser(promo?.text)}
                </div>
                <div onClick={() => this.openCallForm()} className='mt-[27px] cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] w-[343px] h-[48px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                  <DocumentIcon />
                  <div className='text-base'>Запросить КП</div>
                </div>
              </div>
              <img src={promo?.image} width={400} height={306} className='rounded-[14px] h-auto max-w-full' alt='East Dragon' />
            </div>
          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Запросить коммерческое предложение"
          formText="Укажите контактные данные и количество — подготовим КП по выбранному товару. Если нужна доставка, добавьте адрес: рассчитаем условия и сроки под ваш регион."
          productName={(promo?.title || '').replace(/(<([^>]+)>)/gi, "")} // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    )
  }
}

export default Main;
